import { useInfiniteQuery } from 'react-query';
import TradeSearchService from '../../../services/TradeSearchService';
import { SEARCH } from '../../constants/queryDefinition';
import TradeSearchList from '../../models/TradeSearchList';
import { TradePaginationConfig, TradeStateNew } from '../../types/trade';

const useTradeSearchList = (
  isBuy: boolean,
  search: string,
  tradeState: string,
  pageNumber: number
) => {
  const sort = [
    { RELEVANCE: { order: 'DESC' } },
    {
      [isBuy ? 'BUY_TRADE_STATE' : 'SELL_TRADE_STATE']: {
        order: 'DESC'
      }
    },
    { TRADE: { order: 'DESC' } }
  ];

  const requestBody = {
    search,
    sort,
    tradeState: tradeState !== TradeStateNew.ALL ? tradeState : null
  };
  return useInfiniteQuery(
    [isBuy ? SEARCH.BUYLIST : SEARCH.SELLLIST, requestBody, pageNumber],
    async ({
      queryKey,
      pageParam = {
        offset: pageNumber * TradePaginationConfig.maxPerPage,
        allPages: []
      }
    }) => {
      const [, tradeSearchParams] = queryKey;
      const request = {
        ...tradeSearchParams,
        pagination: {
          from: pageParam.offset,
          size: TradePaginationConfig.maxPerPage
        }
      };

      const searchResult = isBuy
        ? await TradeSearchService.getSearchBuyList(request)
        : await TradeSearchService.getSearchSellList(request);

      return new TradeSearchList(searchResult);
    },
    {
      getNextPageParam: (lastPage, allPages) => {
        // Get the total number of trades already fetched to determine offset
        const offset =
          pageNumber * TradePaginationConfig.maxPerPage +
          TradePaginationConfig.maxPerPage;

        const allPagesIdx =
          allPages && allPages.length > 1 ? allPages.length - 1 : 0;
        const noMoreTrades = allPages[allPagesIdx]?.tradeCount - offset <= 0;

        return noMoreTrades
          ? undefined
          : {
              offset,
              allPages
            };
      },
      getPreviousPageParam: (firstPage, allPages) => {
        // Determine if there are trades to be fetched in the previous page based on page number
        const offset =
          pageNumber * TradePaginationConfig.maxPerPage -
          TradePaginationConfig.maxPerPage;

        // Determines if there are still trades in the previous page to be fetched
        const noMoreTrades = offset < 0;

        return noMoreTrades
          ? undefined
          : {
              offset,
              allPages
            };
      },
      refetchOnMount: true,
      staleTime: 1000,
      retry: false,
      enabled: !!search
    }
  );
};

export default useTradeSearchList;
